import React from 'react';
import { useSelector } from 'react-redux';
import { Button, Flex, Well } from '@adobe/react-spectrum';
import { isPlatformAuthorized } from 'app/stores/publish/selectors';
import { getPlatformTag } from 'app/views/components/dialogs/publish/platform';
import { PublishingWell } from 'app/views/components/dialogs/publish/platforms/common/PublishingWell';
import { analytics } from 'app/utils/analytics';
export const PublishWell = (props) => {
    const { platform } = props;
    const platformTag = getPlatformTag(platform);
    const authorized = useSelector((state) => isPlatformAuthorized(state, platform));
    const onAuthorize = () => {
        analytics({
            action: 'PublishPlaform:Authorize',
            label: platformTag,
        });
        window.open(`/platform/authorize/${platformTag}`, '_blank');
    };
    return (React.createElement(PublishingWell, { platform: platform },
        React.createElement(Well, { "data-test-id": "authorize" },
            React.createElement(Flex, { direction: "column", alignItems: "center" },
                props.children,
                !authorized && (React.createElement(Button, { "data-test-id": `authorize-${getPlatformTag(platform)}`, variant: "cta", onPress: onAuthorize, marginTop: "size-250" }, "Authorize"))))));
};
